import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { AccountService } from 'src/app/services/account.service';
import { BlockEmailConfirmModalComponent } from '../block-email-confirm-modal/block-email-confirm-modal.component';

@Component({
    selector: 'email-blocked-component',
    templateUrl: './email-blocked.component.html',
    styleUrls: ['./email-blocked.component.css']
})
export class EmailBlockedComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
        private dialog: MatDialog,
        private toastr: ToastrService,
        private dialogRef: MatDialogRef<EmailBlockedComponent>,
        private accountService: AccountService
    ) { }

    updateEmail() {
        this.dialogRef.close();

        this.router.navigate(['account', 'manage'], { fragment: '8' });
    }

    unblockEmail() {
        const email = this.data.email

        this.accountService.resendVerificationEmail(email)
            .subscribe(res => {
                this.dialogRef.close();

                this.dialog.open(BlockEmailConfirmModalComponent, {
                    width: '500px',
                    autoFocus: false,
                    disableClose: true,
                    data: {
                        email: email,
                        title: 'Unblock Your Email'
                    }
                });
            }, err => {
                this.toastr.error('Unable to Unblock Email', 'Oops!')
            });
    }
}
